<template>
  <b-overlay :show="isLoading" bg-color="transparent" blur="2px">
    <template #overlay>
      <img src="@/assets/lottie/plant.gif" style="width: 5em" />
    </template>

    <b-card no-body class="pt-1 rounded-xl mb-1">
      <b-card-header>
        <h4 v-if="title">{{ title }}</h4>
      </b-card-header>

      <!-- IMAGE PREVIEW -->
      <b-modal
        :id="'image-preview-modal' + previewId"
        hide-footer
        hide-header
        centered
        size="xl"
        modal-class="image-preview-modal"
        content-class="bg-transparent border-0 shadow-none"
      >
        <button
          class="preview-close-btn"
          @click="$bvModal.hide('image-preview-modal' + previewId)"
        >
          X
        </button>

        <img
          v-img-fb="previewImage"
          class="img-fluid rounded mx-auto d-block"
          @contextmenu.prevent
          :draggable="false"
          alt="preview"
        />
        <b-card
          v-if="previewRowData && hasDesc"
          class="rounded mx-auto d-block mt-2"
        >
          <slot
            name="preview-description"
            :rowData="previewRowData"
          >
          </slot>
        </b-card>
      </b-modal>
      
      <b-card-body class="gallery-container">
        <div v-for="value in images" :key="value.id" class="gallery-item">
          <img
            class="gallery-image"
            :src="value && value[imageKey] ? value[imageKey].url : null"
            :alt="value && value[imageKey] ? value[imageKey].filename : null"
            @contextmenu.prevent
            :draggable="false"
            @click="openImagePreview(value[imageKey].url, value)"
            v-b-tooltip.top="'Klik Untuk Preview'"
          />
          <slot
            name="image-title"
            :rowData="value"
          >
          </slot>
        </div>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
export default {
  name: "GrowerWebCardDetailGallery",

  props: {
    title: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default: () => [],
    },
    api: {
      type: String,
      default: "",
    },
    apiParams: {
      type: Object,
      default: () => ({}),
    },
    imageKey: {
      type: String,
      default: 'photo',
    },
    hasDesc: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
      images: [],
      previewImage: null,
      previewRowData: null,
      previewId: null,
    };
  },

  async mounted() {
    if (this.api) {
      await this.getData();
    } else {
      this.images = this.data;
    }
  },

  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!this.api) {
          this.images = val || [];
        }
      },
    },
  },

  methods: {
    openImagePreview(image, rowData) {
      this.previewImage = image;
      this.previewRowData = rowData;
      this.previewId = Date.now();

      this.$nextTick(() => {
        this.$bvModal.show(
          "image-preview-modal" + this.previewId
        );
      });
    },

    async getData() {
      try {
        this.isLoading = true;

        const res = await this.$_api.get(
          this.api,
          this.apiParams
        );

        this.images = res.data || [];
      } catch (err) {
        console.log("getData() error", err);
        this.$_alert.error(err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.gallery-container {
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  padding-bottom: 10px;
}

.gallery-item {
  flex-shrink: 0;
  width: 100px;
}

.gallery-title {
  margin-top: 6px;
  text-align: center;
  font-size: 12px;
  word-break: break-word;
}

.gallery-image {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  object-fit: cover;
  cursor: pointer;
  transition: 0.2s ease;
}

.gallery-image:hover {
  transform: scale(1.03);
}
</style>


// WEBPACK FOOTER //
// src/base/component/card-detail-gallery.vue